import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoggerModule, NGXLogger, NgxLoggerLevel} from 'ngx-logger';
import {IsSingletonGuard} from './guards/is-singleton.guard';
import {HelpersService} from './helpers/helpers.service';
import {LoggerService} from './logger/logger.service';
import {AuthenticationGuard} from './authentication/authentication.guard';
import {AlertService} from './alert/alert.service';
import { AuthService } from './authentication/auth.service';

@NgModule({
  imports: [
    CommonModule,
    LoggerModule.forRoot({
      serverLoggingUrl: '/api/logs',
      level: NgxLoggerLevel.DEBUG,
      serverLogLevel: NgxLoggerLevel.OFF
    })
  ],
  exports: [],
  declarations: [],
  providers: [
    NGXLogger,
    IsSingletonGuard,
    LoggerService,
    AlertService,
    HelpersService,
    AuthService,
    AuthenticationGuard,
  ],
})
export class CoreModule {

  constructor(@Optional() @SkipSelf() parentModule: CoreModule,
              isSingletonGuard: IsSingletonGuard,
              logger: NGXLogger) {
    isSingletonGuard.checkIfSingleton(parentModule, 'CoreModule');
    logger.info('CoreModule initialized.');
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/core/core.module.ts